import { useEffect, useState } from "react";
import { AuthProvider } from "src/contexts/AuthContext/AuthContext";
import WebViewMessageEventEmitter from "src/WebViewEventEmitter";
import AppTemplate from "../containers/AppTemplate/AppTemplate";

const App = () => {
	const [accessToken, setAccessToken] = useState(false);

	useEffect(() => {
		document.title = "Mee Admin";
	}, []);

	useEffect(() => {
		window.authTokens = { accessToken: null, refreshToken: null };

		if (!window.ReactNativeWebView) return;

		WebViewMessageEventEmitter.addListener(
			"AUTH_TOKENS_RESPONSE",
			(authTokens) => {
				window.authTokens = authTokens;
				setAccessToken(Boolean(authTokens));
			}
		);

		WebViewMessageEventEmitter.emit("GET_AUTH_TOKENS");

		return () => {
			WebViewMessageEventEmitter.removeEventListener("AUTH_TOKENS_RESPONSE");
		};
	}, []);

	const isWebview = Boolean(window.ReactNativeWebView);

	if (accessToken && isWebview) {
		return <AppTemplate />;
	}

	return (
		<AuthProvider>
			<AppTemplate />
		</AuthProvider>
	);
};

export default App;
